<template>
  <div data-v-d27b4d60="" data-v-e5781868="" class="myAccount mainContent top50">
    <div data-v-d27b4d60="" class="content">
      <div data-v-d27b4d60="" class="top zeroLevel">
        <div data-v-d27b4d60="" class="box">
          <div data-v-d27b4d60="" class="box-inner">
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text" style="position: relative">
                <img data-v-5a0919b8="" style="border-radius: 50%; width: 60px; border: 2px solid #f0f0f0" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/user.f11fb639.png'" />
                <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
              </div>
            </div>
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text">
                尊敬的 <span data-v-d27b4d60="" style="margin-left: 5px">{{ $store.state.userInfo.username }}</span>
              </div>
            </div>
            <div data-v-d27b4d60="" class="bottom-section">
              <div data-v-d27b4d60="" class="group">
                <div data-v-d27b4d60="" class="inputGroup">
                  <label data-v-d27b4d60="">CNY账户</label>
                  <input data-v-d27b4d60="" type="text" :value="$store.state.userInfo.balance" disabled />
                  <span data-v-d27b4d60="" class="current"
                    ><svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon greenDot">
                      <use data-v-338e1447="" xlink:href="#icon-greenDot"></use>
                    </svg>
                    使用中
                  </span>
                </div>
                <div data-v-d27b4d60="" class="help">
                  <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon iconHelp">
                    <use data-v-338e1447="" xlink:href="#icon-iconHelp"></use>
                  </svg>
                  <div data-v-d27b4d60="" class="message">请选择一种资产进行游戏</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d27b4d60="" class="nav">
        <ul data-v-d27b4d60="">
          <a href="javascript:void(0);" @click="$parent.goNav('/accountSetting')">
            <li data-v-d27b4d60="" class="active">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconSetting">
                <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
              </svg>
              账户设置
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              我的钱包
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/transfer')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconFund">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              转账
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              资金记录
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/activityRecord')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconThumb">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              活动及代理
            </li>
          </a>
        </ul>
      </div>
      <div data-v-02ab71c8="" data-v-d27b4d60="" class="accountSetting">
        <div data-v-02ab71c8="" class="box">
          <div data-v-02ab71c8="" class="title">基础信息 <a data-v-02ab71c8="" @click="$parent.openKefu()">如有问题, 联系客服</a></div>
          <div data-v-02ab71c8="" class="baseInfo">
            <div data-v-68239ec0="" data-v-02ab71c8="" class="content">
              <div data-v-68239ec0="" class="list">
                <div data-v-68239ec0="" class="item">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon iconRealName icon">
                    <use data-v-338e1447="" xlink:href="#icon-iconRealName"></use>
                  </svg>
                  <label data-v-68239ec0="">真实姓名</label>
                  <span data-v-68239ec0="" class="line"></span>

                  <p data-v-68239ec0="" class="realName">{{ $store.state.userInfo.realname }}</p>
                </div>
                <div data-v-68239ec0="" class="item item3">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon registDate icon">
                    <use data-v-338e1447="" xlink:href="#icon-registDate"></use>
                  </svg>
                  <label data-v-68239ec0="">银行卡</label>
                  <a data-v-68239ec0="" href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
                    去查看
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
                <div data-v-68239ec0="" class="item item4">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon registDate icon">
                    <use data-v-338e1447="" xlink:href="#icon-registDate"></use>
                  </svg>
                  <label data-v-68239ec0="">生日</label>
                  <p data-v-68239ec0="">{{ $store.state.userInfo.birthday }}</p>
                  <a data-v-68239ec0="" href="javascript:void(0);" @click="changType(0)">
                    修改
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
                <div data-v-68239ec0="" class="item">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon iconPassword icon">
                    <use data-v-338e1447="" xlink:href="#icon-iconPassword"></use>
                  </svg>
                  <label data-v-68239ec0="">登录密码</label>
                  <span data-v-68239ec0="" class="line"></span>
                  <p data-v-68239ec0="">修改您当前的登录密码</p>
                  <a data-v-68239ec0="" onclick="loginpassword()" @click="changType(5)"
                    >修改
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
                <div data-v-68239ec0="" class="item item2">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon iconMobile icon">
                    <use data-v-338e1447="" xlink:href="#icon-iconMobile"></use>
                  </svg>
                  <label data-v-68239ec0="">手机号</label>
                  <span data-v-68239ec0="" class="line"></span>
                  <!--未绑定-->
                  <p data-v-68239ec0="">{{ $store.state.userInfo.mobile || '您暂未绑定手机号' }}</p>
                  <a data-v-68239ec0="" @click="changType(1)">
                    {{ $store.state.userInfo.mobile ? '修改' : '绑定' }}
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
                <div data-v-68239ec0="" class="item">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon iconFund icon">
                    <use data-v-338e1447="" xlink:href="#icon-iconFund"></use>
                  </svg>
                  <label data-v-68239ec0="">资金密码</label>
                  <span data-v-68239ec0="" class="line"></span>
                  <p data-v-68239ec0="">保证资金安全, 提现需要验证</p>
                  <a data-v-68239ec0="" @click="changType(6)">
                    设置
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
                <div data-v-68239ec0="" class="item item2">
                  <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon iconEmail icon">
                    <use data-v-338e1447="" xlink:href="#icon-iconEmail"></use>
                  </svg>
                  <label data-v-68239ec0="">我的邮箱</label>
                  <span data-v-68239ec0="" class="line"></span>
                  <p data-v-68239ec0="">{{ $store.state.userInfo.email || '邮箱可用于接受订阅通知' }}</p>
                  <a data-v-68239ec0="" href="javascript:void(0);" @click="changType(2)">
                    {{ $store.state.userInfo.email ? '修改' : '绑定' }}
                    <svg data-v-338e1447="" data-v-68239ec0="" aria-hidden="true" class="svg-icon arrowYellow">
                      <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                  ></a>
                </div>
              </div>
              <div data-v-68239ec0="" v-if="type == '0'" class="mask setmobile">
                <div data-v-6146fa75="" data-v-68239ec0="" class="content">
                  <div data-v-6146fa75="" class="backdrop">
                    <div data-v-6146fa75="" class="popup popup2">
                      <div data-v-6146fa75="" class="popHead">
                        生日
                        <a data-v-6146fa75="" class="popClose" @click="closeType"
                          ><svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconClose">
                            <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                        ></a>
                      </div>
                      <div data-v-6146fa75="" class="popContent">
                        <form data-v-6146fa75="">
                          <div data-v-6146fa75="" class="warning message">
                            <svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconWarning">
                              <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use>
                            </svg>
                            记录您的生日，可参与制定活动及保障账户安全
                          </div>
                          <div data-v-6146fa75="" class="popInputGroup popInputGroups">
                            <el-date-picker size="mini" value-format="yyyy-MM-dd" style="background: #fafafa; margin-left: 20px" v-model="birthday" type="date" placeholder="选择日期"> </el-date-picker>
                          </div>

                          <div data-v-6146fa75="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-68239ec0="" v-if="type == '1'" class="mask setmobile">
                <div data-v-6146fa75="" data-v-68239ec0="" class="content">
                  <div data-v-6146fa75="" class="backdrop">
                    <div data-v-6146fa75="" class="popup popup2">
                      <div data-v-6146fa75="" class="popHead">
                        绑定手机号
                        <a data-v-6146fa75="" class="popClose" @click="closeType"
                          ><svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconClose">
                            <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                        ></a>
                      </div>
                      <div data-v-6146fa75="" class="popContent">
                        <form data-v-6146fa75="">
                          <div data-v-6146fa75="" class="warning message">
                            <svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconWarning">
                              <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use>
                            </svg>
                            绑定手机号可保证您的账号安全
                          </div>
                          <div data-v-6146fa75="" class="popInputGroup">
                            <label data-v-6146fa75=""
                              ><svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconPopMobile icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconPopMobile"></use></svg
                            ></label>
                            <input data-v-6146fa75="" maxlength="12" v-model="mobile" type="text" placeholder="请输入您的手机号" class="" />
                          </div>

                          <div data-v-6146fa75="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-68239ec0="" v-if="type == '2'" class="mask setemail">
                <div data-v-60d8da04="" data-v-68239ec0="" class="content">
                  <div data-v-60d8da04="" class="backdrop">
                    <div data-v-60d8da04="" class="popup popup2">
                      <div data-v-60d8da04="" class="popHead">
                        绑定邮箱
                        <a data-v-60d8da04="" class="popClose" @click="closeType"
                          ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconClose">
                            <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                        ></a>
                      </div>
                      <div data-v-60d8da04="" class="popContent">
                        <form data-v-60d8da04="">
                          <div data-v-60d8da04="" class="warning message">
                            <svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconWarning">
                              <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use>
                            </svg>
                            邮箱可用于接收订阅通知
                          </div>
                          <div data-v-60d8da04="" class="popInputGroup">
                            <label data-v-60d8da04=""
                              ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconEmail icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconEmail"></use></svg
                            ></label>
                            <input data-v-60d8da04="" v-model="email" type="text" placeholder="请输入您的邮箱地址" class="" />
                          </div>

                          <div data-v-60d8da04="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-68239ec0="" v-if="type == '5'" class="mask loginpassword">
                <div data-v-4a4c4666="" data-v-68239ec0="" class="content">
                  <div data-v-4a4c4666="" class="backdrop">
                    <div data-v-4a4c4666="" class="popup popup2">
                      <div data-v-4a4c4666="" class="popHead">
                        修改登录密码
                        <a data-v-4a4c4666="" class="popClose" @click="closeType"
                          ><svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon iconClose">
                            <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                        ></a>
                      </div>
                      <div data-v-4a4c4666="" class="popContent">
                        <form data-v-4a4c4666="">
                          <div data-v-4a4c4666="" class="popInputGroup">
                            <label data-v-4a4c4666=""
                              ><svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon iconPopPassword icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconPopPassword"></use></svg
                            ></label>
                            <input data-v-4a4c4666="" maxlength="16" v-model="password" autocomplete="off" type="password" placeholder="请输入当前登录密码" class="" />
                          </div>
                          <div data-v-4a4c4666="" class="popInputGroup">
                            <label data-v-4a4c4666=""
                              ><svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon iconNewPassword icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconNewPassword"></use></svg
                            ></label>
                            <input data-v-4a4c4666="" maxlength="16" autocomplete="off" v-model="paypassword" type="password" placeholder="请输入新登录密码(6-16位数字及字母)" />
                          </div>
                          <div data-v-4a4c4666="" class="popInputGroup">
                            <label data-v-4a4c4666=""
                              ><svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon iconConfirmPassword icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconConfirmPassword"></use></svg
                            ></label>
                            <input data-v-4a4c4666="" autocomplete="new-password" maxlength="16" v-model="paypassword1" type="password" placeholder="请再次输入新登录密码" />
                          </div>
                          <div data-v-4a4c4666="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                          <p data-v-4a4c4666="">
                            遇到问题了？
                            <a data-v-4a4c4666=""
                              >联系客服
                              <svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon arrowYellow">
                                <use data-v-338e1447="" xlink:href="#icon-arrowYellow"></use></svg
                            ></a>
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-68239ec0="" v-if="type == '6'" class="mask moneypassword">
                <div data-v-39db84f6="" data-v-68239ec0="" class="content">
                  <div data-v-39db84f6="" class="backdrop">
                    <div data-v-39db84f6="" class="popup popup2">
                      <div data-v-39db84f6="" class="popHead">
                        设置资金密码
                        <a data-v-39db84f6="" class="popClose" @click="closeType"
                          ><svg data-v-338e1447="" data-v-39db84f6="" aria-hidden="true" class="svg-icon iconClose">
                            <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                        ></a>
                      </div>
                      <div data-v-39db84f6="" class="popContent">
                        <form data-v-39db84f6="">
                          <div data-v-39db84f6="" class="warning message">
                            <svg data-v-338e1447="" data-v-39db84f6="" aria-hidden="true" class="svg-icon iconWarning">
                              <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use></svg
                            ><span data-v-39db84f6="">设置资金密码可保证您的资金安全, 提现需要验证</span>
                          </div>
                          <div data-v-39db84f6="" class="popInputGroup">
                            <label data-v-39db84f6=""
                              ><svg data-v-338e1447="" data-v-39db84f6="" aria-hidden="true" class="svg-icon iconPopFund icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconPopFund"></use></svg
                            ></label>
                            <input data-v-39db84f6="" autocomplete="off" v-model="password" type="password" placeholder="请输入您的旧的资金密码(6位纯数字)" />
                          </div>
                          <div data-v-39db84f6="" class="popInputGroup">
                            <label data-v-39db84f6=""
                              ><svg data-v-338e1447="" data-v-39db84f6="" aria-hidden="true" class="svg-icon iconConfirmFund icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconConfirmFund"></use></svg
                            ></label>
                            <input data-v-39db84f6="" autocomplete="new-password" v-model="paypassword" type="password" placeholder="请输入新的的资金密码" class="" />
                          </div>
                          <div data-v-4a4c4666="" class="popInputGroup">
                            <label data-v-4a4c4666=""
                              ><svg data-v-338e1447="" data-v-4a4c4666="" aria-hidden="true" class="svg-icon iconConfirmPassword icon">
                                <use data-v-338e1447="" xlink:href="#icon-iconConfirmPassword"></use></svg
                            ></label>
                            <input data-v-4a4c4666="" autocomplete="new-password" maxlength="16" v-model="paypassword1" type="password" placeholder="请再次输入新密码" />
                          </div>
                          <div data-v-39db84f6="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'accountSetting',
  data() {
    return {
      type: null,
      birthday: null,
      mobile: null,
      email: null,
      password: null,
      paypassword: null,
      paypassword1: null,
    };
  },
  created() {
    let that = this;
    that.$parent.showLoading();
    that.$parent.getUserInfo();
    setTimeout(() => {
      that.$parent.hideLoading();
    }, 1000);
  },
  methods: {
    onchangemd(e) {
      let that = this;

      console.log(e.target.files);
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item);
      });
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfoShowLoding();
        that.$parent.hideLoading();
      });
    },
    changType(val) {
      let that = this;
      that.type = val;
      that.birthday = null;
      that.mobile = null;
      that.email = null;
      that.password = null;
      that.paypassword = null;
      that.paypassword1 = null;
    },
    isOk() {
      let that = this;
      let val = that.type;
      let url = '';
      let info = {};
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (val == 0) {
        url = '/api/updateuserinfo';

        info.birthday = that.birthday;
        info.mobile = userInfo.mobile;
        info.email = userInfo.email;
        if (!info.birthday) {
          that.$parent.showTost(0, '请输入日期');
          return;
        }
      }
      if (val == 5) {
        info.password = that.password;
        info.paypassword = that.paypassword;

        url = '/api/editPassword';
        if (!that.password) {
          that.$parent.showTost(0, '请输入旧密码');
          return;
        }
        if (!that.paypassword) {
          that.$parent.showTost(0, '请输入新密码');
          return;
        }
        if (that.password.length < 6) {
          that.$parent.showTost(0, '请输入正确的旧密码长度');
          return;
        }
        if (that.paypassword.length < 6) {
          that.$parent.showTost(0, '请输入正确的新密码长度');
          return;
        }
        if (!that.paypassword1) {
          that.$parent.showTost(0, '请输入确认密码');
          return;
        }
        if (that.paypassword1 != that.paypassword) {
          that.$parent.showTost(0, '两次密码不一致！');
          return;
        }
        if (that.password == that.paypassword) {
          that.$parent.showTost(0, '新旧密码不能一致！');
          return;
        }
      }
      if (val == 1) {
        url = '/api/updateuserinfo';
        info.mobile = that.mobile;
        info.birthday = userInfo.birthday;
        info.email = userInfo.email;
        let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!regExp.test(that.mobile)) {
          that.$parent.showTost(0, '请输入正确手机号');
          return;
        }
      }
      if (val == 6) {
        url = '/api/editPayPassword';
        info.password = that.password;
        info.paypassword = that.paypassword;
        if (!that.password) {
          that.$parent.showTost(0, '请输入旧密码');
          return;
        }
        if (!that.paypassword) {
          that.$parent.showTost(0, '请输入新密码');
          return;
        }
        if (that.password.length < 6) {
          that.$parent.showTost(0, '请输入正确的旧密码长度');
          return;
        }
        if (that.paypassword.length < 6) {
          that.$parent.showTost(0, '请输入正确的新密码长度');
          return;
        }
        if (!that.paypassword1) {
          that.$parent.showTost(0, '请输入确认密码');
          return;
        }
        if (that.paypassword1 != that.paypassword) {
          that.$parent.showTost(0, '两次密码不一致！');
          return;
        }
        if (that.password == that.paypassword) {
          that.$parent.showTost(0, '新旧密码不能一致！');
          return;
        }
      }
      if (val == 2) {
        url = '/api/updateuserinfo';
        info.email = that.email;
        info.mobile = userInfo.mobile;
        info.birthday = userInfo.birthday;
        let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (!regEmail.test(that.email)) {
          that.$parent.showTost(0, '请输入正确邮箱');
          return;
        }
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          that.$parent.getUserInfo();
          that.type = null;
          if (val == 5) {
            that.$parent.showLoading();
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeT();
            that.$parent.closeDaoTime();
            setTimeout(() => {
              that.$parent.hideLoading();
            }, 1000);
          }
        }
      });
    },
    closeType() {
      this.type = null;
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-3b1c96fc.08284057.css';
.buttonSolid {
  cursor: pointer;
}
.el-input__inner {
  background: #fff !important;
}
.el-input--mini .el-input__inner {
  width: 100%;

  outline: none;
  border: 1px solid #dbdbdb !important;
  border-radius: 4px;
}
.popInputGroups .el-input__inner,
.el-input__inner input {
  background-color: none !important;
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}

// 白色主题样式覆盖
.myAccount[data-v-d27b4d60] {
  background: #f9f9f9;
  padding: .2rem 0;
}

.myAccount .top .box[data-v-d27b4d60] {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  background-image: none !important;
}

.myAccount .username[data-v-d27b4d60] {
  color: #333 !important;
}

.myAccount .top .box .group .inputGroup[data-v-d27b4d60] {
  background: #f5f5f5 !important;
}

.myAccount .nav ul li[data-v-d27b4d60] {
  background: #f0f0f0;
  color: #666;
}

.myAccount .nav ul li.active[data-v-d27b4d60],
.myAccount .nav ul li:hover[data-v-d27b4d60] {
  background: #ffcb4c;
  color: #fff;
}

.myAccount .nav ul li.active .icon[data-v-d27b4d60],
.myAccount .nav ul li:hover .icon[data-v-d27b4d60] {
  color: #fff;
}

.accountSetting .box[data-v-02ab71c8] {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 0.2rem;
}

.accountSetting .title[data-v-02ab71c8] {
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 0.15rem;
  margin-bottom: 0.2rem;
}

.accountSetting .title a[data-v-02ab71c8] {
  color: #ffcb4c;
}

.item[data-v-68239ec0] {
  border-bottom: 1px solid #f0f0f0;
  padding: 0.15rem 0;
}

.item label[data-v-68239ec0] {
  color: #666;
}

.item p[data-v-68239ec0] {
  color: #333;
}

.item .line[data-v-68239ec0] {
  background: #f0f0f0;
}

.item a[data-v-68239ec0] {
  color: #ffcb4c;
}

.backdrop .popup[data-v-d27b4d60] {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.popHead[data-v-6146fa75],
.popHead[data-v-60d8da04],
.popHead[data-v-4a4c4666],
.popHead[data-v-39db84f6] {
  background: #f9f9f9;
  color: #333;
}

.popContent[data-v-6146fa75],
.popContent[data-v-60d8da04],
.popContent[data-v-4a4c4666],
.popContent[data-v-39db84f6] {
  color: #333;
}

.warning.message[data-v-6146fa75],
.warning.message[data-v-60d8da04],
.warning.message[data-v-39db84f6] {
  color: #666;
  background: #fff8e1;
  border-left: 3px solid #ffcb4c;
  padding: 0.1rem;
  border-radius: 4px;
}

.popInputGroup input[data-v-6146fa75],
.popInputGroup input[data-v-60d8da04],
.popInputGroup input[data-v-4a4c4666],
.popInputGroup input[data-v-39db84f6] {
  border: 1px solid #ddd;
  color: #333;
}

.popBtn.buttonSolid[data-v-6146fa75],
.popBtn.buttonSolid[data-v-60d8da04],
.popBtn.buttonSolid[data-v-4a4c4666],
.popBtn.buttonSolid[data-v-39db84f6] {
  background: #ffcb4c;
  color: #fff;
  border: none;
}

.popBtn.buttonSolid:hover[data-v-6146fa75],
.popBtn.buttonSolid:hover[data-v-60d8da04],
.popBtn.buttonSolid:hover[data-v-4a4c4666],
.popBtn.buttonSolid:hover[data-v-39db84f6] {
  background: #f9c237;
}

.myAccount .top.silverLevel .box[data-v-d27b4d60],
.myAccount .top.goldLevel .box[data-v-d27b4d60],
.myAccount .top.platinumLevel .box[data-v-d27b4d60],
.myAccount .top.diamondLevel .box[data-v-d27b4d60],
.myAccount .top.blackGoldLevel .box[data-v-d27b4d60] {
  background-image: none !important;
}

.myAccount .top.silverLevel .inputGroup[data-v-d27b4d60],
.myAccount .top.goldLevel .inputGroup[data-v-d27b4d60],
.myAccount .top.platinumLevel .inputGroup[data-v-d27b4d60],
.myAccount .top.diamondLevel .inputGroup[data-v-d27b4d60],

.myAccount .top.silverLevel .promo[data-v-d27b4d60],
.myAccount .top.goldLevel .promo[data-v-d27b4d60],
.myAccount .top.platinumLevel .promo[data-v-d27b4d60],
.myAccount .top.diamondLevel .promo[data-v-d27b4d60],
.myAccount .top.blackGoldLevel .promo[data-v-d27b4d60] {
  background-image: none !important;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.myAccount .top .promo h3[data-v-d27b4d60],
.myAccount .top .promo h2[data-v-d27b4d60] {
  color: #333 !important;
}
.myAccount .top .promo p[data-v-d27b4d60] {
  color: #666 !important;
}
// 增强基础信息列表样式，确保颜色正确显示
.list[data-v-68239ec0] {
   
  // 增加容器特异性
  .item[data-v-68239ec0] {
	  background: #f9f9f9;	
    // 确保每个项的基础样式
    label[data-v-68239ec0] {
      color: #666 !important; // 强制应用标签颜色
    }
    
    p[data-v-68239ec0] {
      color: #333 !important; // 强制应用内容文本颜色
    }
    
    .link-action[data-v-68239ec0] {
      color: #ffcb4c !important; // 强制应用链接颜色
      &:hover {
        color: #f9c237 !important; // 链接 hover 效果
      }
    }
    
    .line[data-v-68239ec0] {
      background-color: #f0f0f0 !important; // 强制应用分隔线颜色
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/accountSetting.vue